export default __webpack_public_path__ + "55d445d4917e31c08bb2f1571c466fcb.png";